import React, {useEffect, useRef, useState} from "react";
import ReactMarkdown from "react-markdown";
import { Modal, Collapse, Button } from "components";
import { ChevronDown, ChevronUp } from "../../../layouts/dashboard/sidebar/icons/icons/icons";

import './changelog-modal.scss';


const ChangelogModal = ({ changelogs, isOpen, onClose }) => {

    const [ collapseOpen, setCollapseOpen ] = useState(null);
    const changelogRef = useRef(null);

    const style = {
        content: {
            maxWidth: 'calc(100vw - 5rem)',
            maxHeight: 'calc(100vh - 5rem)',
            height: 640,
            width: 960,
        },
    };

    useEffect(() => {
        if(collapseOpen && changelogRef && changelogRef.current) {
            setTimeout(() => {
                changelogRef.current.scrollIntoView({ behavior: 'smooth' })
            }, 500)
        }
    }, [collapseOpen, changelogRef, changelogRef.current]);

    useEffect(() => {
        setCollapseOpen(changelogs[changelogs.length - 1].version);
    }, []);

    return (
        <Modal open={isOpen} closeModal={onClose} style={style} className="changelog-modal">
            <div className="paylixecommerce-modal-header" style={{ textTransform: 'capitalize' }}>
                Changelog
            </div>

            <div className="changelog-modal-body mb-0">
                <div className="changelog-modal-list">
                    {changelogs.map(({ version, changelog, preview_url }) => (
                        <div className="changelog-modal-list-item" key={version}>
                            <div className="changelog-modal-list-subheader" onClick={() => setCollapseOpen(collapseOpen === version ? null : version)} ref={collapseOpen === version ? changelogRef : null} >
                                <div>{version}</div>
                                {collapseOpen === version ? <ChevronUp /> : <ChevronDown />}
                            </div>
                            <Collapse isOpen={collapseOpen === version}>
                                <div className="changelog-modal-list-body">
                                    {preview_url ? <div style={{ width: 310, height: 200, overflow: "hidden",
                                        border: "1px solid var(--black9)",
                                        borderRadius: ".5rem",
                                        marginBottom: "1rem"
                                    }}>
                                        <img src={preview_url} alt="" style={{ width: "100%", height: "100%" }} />
                                    </div> : null}
                                    <ReactMarkdown>
                                        {changelog}
                                    </ReactMarkdown>
                                </div>
                            </Collapse>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};

export default ChangelogModal;
